const tripCityList = [
  {
    Id: 176,
    ChineseName: "阿姆斯特丹",
    Name: "Amsterdam",
    country: "Netherlands",
    code: "AMS",
  },
  {
    Id: 176,
    ChineseName: "阿姆斯特丹",
    Name: "Amstelveen",
    country: "Netherlands",
    code: "AMS",
  },
  {
    Id: 338,
    ChineseName: "伦敦",
    Name: "London",
    country: "United Kingdom",
  },
  {
    Id: 1731,
    ChineseName: "爱因霍温",
    Name: "Eindhoven",
    country: "Netherlands",
  },
];

export default tripCityList;